import { AfterContentInit, Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { LayerListService } from '../../../services/layer-list.service';
import { LayerListGroup, LayerListId } from './layer-list.model';
export * from './layer-list.model';
@Component({
  selector: 'lib-layer-list',
  templateUrl: './layer-list.component.html',
  styleUrls: ['./layer-list.component.scss']
})
export class LayerListComponent implements OnInit, OnDestroy, AfterContentInit {
  selected: LayerListId[] = [];
  items: LayerListGroup[] = [
    {
      title: 'Nền',
      items: [
        { isSelected: false, id: LayerListId.NenDuongPho, title: 'Nền đường phố', avatar: './assets/layer-list/giao-thong.jpg' },
        { isSelected: false, id: LayerListId.NenVeTinh, title: 'Nền vệ tinh', avatar: './assets/layer-list/ve-tinh.png' }
      ]
    }
  ];

  subcribeLayerSelected: Subscription;

  constructor(
    private service: LayerListService
  ) {

  }

  ngOnInit() {
    this.subcribeLayerSelected = this.service.layerSelected.subscribe(value => {
      this.selected = value.selected;
      this.refreshItems();
    });
  }

  ngOnDestroy(): void {
    this.subcribeLayerSelected.unsubscribe();
  }

  ngAfterContentInit(): void {
  
  }

  private refreshItems() {
    this.items.forEach(item => {
      item.items.forEach(item1 => item1.isSelected = this.selected.indexOf(item1.id) > -1);
    });
  }

  handleClick(id: LayerListId) {
    // nếu select rồi thì hủy select
    if (this.selected.indexOf(id) > -1) {
      this.service.remove(id);
    } else {
      this.service.add(id);
    }
  }
}
